import { black } from '@/constants/Colors';
import { textos, tituloH1 } from '@/constants/Dimens';
import { Typography } from '@mui/material';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface TextoDescripcionProps {
    children?: React.ReactNode;
    color?: string;
    style?: React.CSSProperties;
}

function TextoDescripcion({ children, color, style }: TextoDescripcionProps) {
    //Tamaño de texto a 25 px
    //Color de texto a primario

    const styleDefault: React.CSSProperties = {
        fontSize: textos,
        color: color ? color : 'black',
        userSelect: 'none',
        textDecoration: 'none',
        fontWeight: '300'
    };


    return (
        <Typography style={{ ...styleDefault, ...style }} variant="body1" component="span">
            {children}
        </Typography>
    );
}

export default TextoDescripcion;